import PropTypes from 'prop-types';
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import store from 'store';
import * as subscriptionUtils from '../../../shared/subscriptions';
import { window } from '../../globals';
import { SupportLink } from '../generic/Link';

type IModalPostUpgradeState = {
  show?: boolean;
  downgraded?: boolean;
};

class ModalPostUpgrade extends Component<Record<string, never>, IModalPostUpgradeState> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      downgraded: false,
    };
  }

  feedbackNode; // define for ts compilation

  componentDidMount() {
    if (!window.user || !window.user.organization) return;

    const lastSub = store.get('oldSubscription');
    store.set('oldSubscription', null); // destroy key regardless
    if (lastSub) {
      const lastSubInfo = subscriptionUtils.getSubscription({ plan: lastSub });
      const currentSubInfo = subscriptionUtils.getSubscription({ plan: window.user.organization.stripe_plan });
      this.setState({
        show: true,
        downgraded: lastSubInfo.price > currentSubInfo.price,
      });
      if (this.feedbackNode) this.feedbackNode.focus();
    }
  }

  render() {
    if (!window.user || !window.user.organization) return null;

    const currentSub = subscriptionUtils.getSubscription({ plan: window.user.organization.stripe_plan });
    return (
      <Modal show={this.state.show} backdrop animation onHide={() => this.setState({ show: false })}>
        <Modal.Header closeButton>
          <Modal.Title>
            {this.state.downgraded ? 'Your subscription has changed.' : 'Your subscription has been upgraded!'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.state.downgraded ? (
            <div>
              <p>We would love for you to tell us a bit about why you chose to downgrade your subscription.</p>
              <SupportLink
                className="btn btn-primary margin-right-sm"
              >
                Send Feedback
              </SupportLink>
              <a className="btn" onClick={() => this.setState({ show: false })}>Close</a>
            </div>
          ) : (
            <div className="text-center">
              <img src="/img/success-modal-image.svg" width="100%" />
              <h3>
                Upgraded to <b>{currentSub.label}</b> tier
              </h3>
              <p>You unlocked new features in FOSSA</p>
              <br />
              <a className="btn" onClick={() => this.setState({ show: false })}>
                Sounds Good!
              </a>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

export default ModalPostUpgrade;
